import { useEffect } from 'react';
import { useEffectiveReducedMotion } from '@/shared/lib/hooks/useEffectiveReducedMotion';
import { useA11yStore } from '@/shared/store/a11yStore';

/**
 * Без MotionConfig, чтобы не тянуть framer-motion в бандл лендинга: компоненты
 * с motion.* сами читают useEffectiveReducedMotion() из ленивых чанков.
 */
export function A11yProvider({ children }: { children: React.ReactNode }) {
  const fontScale = useA11yStore((s) => s.fontScale);
  const effectiveReducedMotion = useEffectiveReducedMotion();

  useEffect(() => {
    document.documentElement.style.setProperty('--font-scale', `${fontScale}px`);
  }, [fontScale]);

  useEffect(() => {
    document.documentElement.classList.toggle('reduce-motion', effectiveReducedMotion);
  }, [effectiveReducedMotion]);

  return <>{children}</>;
}
